(function () {
  function swiperInit(section) {
    if (!section) return;
    subSliderInit(section);
    sliderInit(section);
    popupSliderInit(section);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!window.Shopify.designMode) {
      swiperInit(e.target);
    }
  });

  swiperInit(document.currentScript?.parentElement);
})();
